import axios from "axios";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import "./index.css";
import { MdArrowDropDown } from "react-icons/md";
import getDate from "../../../../utils/getDate";
import deepCopy from "../../../../utils/deepcopy";
import PopConfirm from "../../../../common/PopConfirm";

export default function ChildComment(props) {
  const { handleAlert, setReplyTo, mentionFocus, user } = props;

  const [cookies, setCookie] = useCookies([""]);

  const [comments, setComments] = useState([]);
  const [replyFold, setReplyFold] = useState({});
  const [reload, setReload] = useState(false);
  const [onDelete, setOnDelete] = useState(false);
  const [limit, setLimit] = useState(10);
  const [showCommentsLoading, setShowCommentsLoading] = useState(false);

  const sortComments = (comments) => {
    let newComments = deepCopy(comments);
    if (newComments.length > 1) {
      newComments.sort((a, b) => {
        return new Date(b.datetime) - new Date(a.datetime);
      });
    }
    return newComments;
  };

  useEffect(() => {
    if (props.model && props.model.id) {
      if (props.parentComment.id === -1) {
        axios({
          method: "post",
          url: `/api/m2d/comments/getCommentsByModel`,
          data: {
            mid: props.model.id,
            limit: limit,
          },
        }).then((res) => {
          setComments(sortComments(res.data));
        });
      } else {
        const cook = document.cookie.includes("acceptedCookiePolicy=true") ? ["replyFold"] : undefined;
        if (!cook || (cook && cook[props.parentComment.id])) {
          axios({
            method: "post",
            url: `/api/m2d/comments/getCommentsByParentId`,
            data: {
              cid: props.parentComment.id,
              limit: limit,
            },
          }).then((res) => {
            setComments(sortComments(res.data));
          });
        }
      }
    }

    if (props.project && props.project.id) {
      if (props.parentComment.id === -1) {
        axios({
          method: "post",
          url: `/api/m2d/comments/getCommentsByProject`,
          data: {
            pid: props.project.id,
            limit: limit,
          },
        }).then((res) => {
          setComments(sortComments(res.data));
        });
      } else {
        const cook = document.cookie.includes("acceptedCookiePolicy=true") ? cookies["replyFold"] : undefined;
        if (!cook || (cook && cook[props.parentComment.id])) {
          axios({
            method: "post",
            url: `/api/m2d/comments/getCommentsByParentId`,
            data: {
              cid: props.parentComment.id,
              limit: limit,
            },
          }).then((res) => {
            setComments(sortComments(res.data));
          });
        }
      }
    }
  }, [props.model, props.project, props.parentReload, reload, cookies, limit, props.parentComment.id]);

  useEffect(() => {
    if (onDelete) {
      setOnDelete(false);
      handleAlert("success", "Successfully deleted!");
    }
  }, [onDelete, props, handleAlert]);

  useEffect(() => {
    if (document.cookie.includes("acceptedCookiePolicy=true") && cookies["replyFold"]) {
      setReplyFold(cookies["replyFold"]);
    }
  }, [cookies]);

  const handleShowReply = (e) => {
    const tmp = JSON.parse(JSON.stringify(replyFold));
    tmp[e.currentTarget.id] = !replyFold[e.currentTarget.id];
    if (document.cookie.includes("acceptedCookiePolicy=true")) {
      setCookie("replyFold", tmp, {
        expires: new Date(new Date().getTime + 2 * 3600 * 1000),
      });
    }

    setReplyFold(tmp);
  };

  const handleReply = (cid, username) => {
    mentionFocus();
    setReplyTo({ cid, username });
  };

  const handleDeleteComment = (id) => {
    axios({
      method: "post",
      url: `/api/m2d/comments/delete`,
      data: {
        cid: id,
      },
    })
      .then(() => {
        // window.location.reload(false)
        setReload(!reload);
        setOnDelete(true);
      })
      .catch((err) => {
        handleAlert("error", err, 3500);
      });
  };

  const handleMoreComments = () => {
    setShowCommentsLoading(true);
    if (props.parentComment.id === -1) {
      axios({
        method: "post",
        url: `/api/comments/getCommentsByModel`,
        data: {
          mid: props.model.id,
          limit: limit + 10,
        },
      }).then((res) => {
        setLimit(limit + 10);
        setComments([...comments, ...sortComments(res.data)]);
        setShowCommentsLoading(false);
      });
    } else {
      const cook = document.cookie.includes("acceptedCookiePolicy=true") ? cookies["replyFold"] : undefined;
      if (!cook || (cook && cook[props.parentComment.id])) {
        axios({
          method: "post",
          url: `/api/comments/getCommentsByParentId`,
          data: {
            cid: props.parentComment.id,
            limit: limit + 10,
          },
        }).then((res) => {
          setLimit(limit + 10);
          setComments([...comments, ...sortComments(res.data)]);
          setShowCommentsLoading(false);
        });
      }
    }
  };

  const handleCancel = () => {
    console.log("Canceled");
  };

  return (
    <>
      {comments && comments.length > 0
        ? comments.map((comment) => {
          return (
            <div className="comments" key={`comment-${comment.id}`}>
              <div className="main-comment">
                <div
                  className="main-commenter"
                  id={comment.id}
                  onClick={handleShowReply}
                >
                  <div className={`user-name`}>@{`${comment.user.firstName} ${comment.user.lastName}`}</div>
                  &nbsp;{props.parentComment.id === -1 ? "" : "replies to"}
                  {props.parentComment.id === -1 ? (
                    ""
                  ) : (
                    <div className={`user-name`}>
                      &nbsp;{`@${props.parentComment.user.firstName} ${props.parentComment.user.lastName}`}
                    </div>
                  )}
                  {!comment.childComment ||
                    comment.childComment.length === 0 ? null : (
                    <div
                      className={`comment-icon${replyFold[comment.id] ? "-down" : ""
                        }`}
                    >
                      <MdArrowDropDown style={{ fontSize: 28 }} />
                    </div>
                  )}
                </div>
                <div
                  className="main-comment-content"
                  id={comment.id}
                  onClick={handleShowReply}
                >
                  {comment.comment}
                </div>
                {comment.image ? (
                  <div
                    className="main-comment-img"
                    id={comment.id}
                    onClick={handleShowReply}
                  >
                    img here
                  </div>
                ) : null}

                <div className="comment-bot-bar">
                  <div className="comment-datetime">
                    {getDate(comment.datetime)}
                  </div>
                  {!user || user.id === -1 ? null : (
                    <div
                      className="comment-reply-btn"
                      id={comment.id}
                      onClick={() => handleReply(comment.id, `${comment.user.firstName} ${comment.user.lastName}`)}
                    >
                      Reply
                    </div>
                  )}

                  {comment.user.id === parseInt(user.id) ? (
                    <PopConfirm
                      message="Are you sure you want to delete this item?"
                      onConfirm={() => handleDeleteComment(comment.id)}
                      onCancel={handleCancel}
                    >
                      <div className="comment-delete-btn">Delete</div>
                    </PopConfirm>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {comment.childComment &&
                comment.childComment.length > 0 &&
                replyFold[comment.id] === true ? (
                <div className="reply-comment">
                  <ChildComment
                    parentComment={comment}
                    model={props.model}
                    project={props.project}
                    user={user}
                    setReplyTo={setReplyTo}
                    mentionFocus={mentionFocus}
                    handleAlert={handleAlert}
                    parentReload={reload}
                  />
                </div>
              ) : null}
            </div>
          );
        })
        : ""}

      {comments.length === limit ? (
        <div className="show-more-comments" onClick={handleMoreComments}>
          {showCommentsLoading ? "Loading..." : "----- Show more -----"}
        </div>
      ) : (
        ""
      )}
    </>
  );
}
